export type SummaryHasDetailsParams = {
  discountCents: number;
  isCouponApplied: boolean;
  showServiceFee: boolean;
};

export const summaryHasDetails = ({
  discountCents,
  isCouponApplied,
  showServiceFee,
}: SummaryHasDetailsParams): boolean => discountCents > 0 || isCouponApplied || showServiceFee;
